<template>
  <div class="mt-48 rights-issue">
    <div v-if="showDisclaimer" class="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div class="bg-white rounded-lg max-w-4xl max-h-[90vh] overflow-y-auto p-8">
        <h1 class="text-3xl font-bold mb-6">Viktig information</h1>
        
        <div class="space-y-4 text-sm leading-relaxed">
          <p>
            Windon Energy Group AB ("Bolaget") har på grund av legala restriktioner avgränsat tillgängligheten för den här delen av webbplatsen. Vi ber dig därför att ta del av följande information och lämna följande bekräftelse varje gång du önskar få tillgång till denna webbplats. Vänligen notera att villkoren kan komma att förändras och att det därför är viktigt att du läser villkoren varje gång du besöker denna webbplats.
          </p>
          
          <p>
            Informationen på denna del av webbplatsen för Bolaget är inte avsedd för, och får inte, direkt eller indirekt, helt eller delvis, åtkommas av eller distribueras eller spridas till personer som bor eller befinner sig i USA (innefattande dess territorier och provinser, varje stat i USA samt District of Columbia, "USA"), Australien, Belarus, Hong Kong, Japan, Kanada, Nya Zeeland, Ryssland, Schweiz, Singapore, Sydafrika, Sydkorea eller någon annan jurisdiktion där/om sådan distribution kräver ytterligare prospekt, registrering eller andra åtgärder än de som följer av svensk rätt eller annars strider mot reglerna i sådan jurisdiktion eller inte kan ske utan tillämpning av undantag från sådan åtgärd. Informationen får inte heller i övrigt distribueras eller publiceras i någon jurisdiktion annat än i enlighet med gällande lagar och regler. Mottagaren av informationen är skyldig att informera sig om och följa dessa restriktioner, och får inte publicera eller distribuera informationen i strid med tillämpliga lagar och regler. Åtgärder i strid med dessa restriktioner kan utgöra brott mot tillämplig värdepapperslagstiftning.
          </p>
          
          <p>
            Värdepapper i Bolaget som omnämns på denna webbplats ("Värdepapper") har inte registrerats och kommer inte att registrerats enligt den vid var tid gällande U.S. Securities Act från 1933 ("Securities Act") och får inte erbjudas eller säljas i USA utan registrering eller utan tillämpning av ett undantag från, eller genom en transaktion som inte omfattas av, registreringskraven i Securities Act och i överenstämmelse med samtliga tillämpliga värdepapperslagar i varje delstat eller annan jurisdiktion i USA.
          </p>
          
          <p>
            Inom det europeiska ekonomiska samarbetsområdet ("EES") lämnas inget erbjudande till allmänheten av Värdepapper i andra länder än Sverige. I andra medlemsländer i den Europeiska unionen ("EU") kan ett sådant erbjudande endast lämnas i enlighet med undantag i Prospektförordningen (EU) 2017/1129 ("Prospektförordningen"). I andra länder i EES som har implementerat Prospektförordningen i nationell lagstiftning kan ett sådant erbjudande endast lämnas i enlighet med undantag i Prospektförordningen samt i enlighet med varje relevant implementeringsåtgärd. I övriga länder i EES som inte har implementerat Prospektförordningen i nationell lagstiftning kan ett sådant erbjudande endast lämnas i enlighet med tillämpligt undantag i den nationella lagstiftningen.
          </p>
          
          <p>
            I alla EES-medlemsstater, förutom Sverige, riktas informationen som finns på denna del av Bolagets webbplats endast till "kvalificerade investerare" i den medlemsstaten i den mening som avses i Prospektförordningen.
          </p>
          
          <p>
            I Storbritannien får informationen som finns på denna del av Bolagets webbplats endast distribueras till, och är endast avsedd för, "kvalificerade investerare" (i den mening som avses i den brittiska versionen av EU:s prospektförordning (2017/1129/EU) vilket är en del av Storbritanniens lag i kraft av European Union (Withdrawal) Act 2018 gällande (i) personer som har yrkeserfarenhet i frågor som rör investeringar som faller inom definitionen av "professionella investerare" i artikel 19.5 i Financial Services and Markets Act 2000 (Financial Promotion) Order 2005 ("Förordningen"); eller (ii) företag med hög nettoförmögenhet som omfattas av artikel 49.2 (a) till (d) i Förordningen (alla sådana personer betecknas tillsammans som "relevanta personer"). Värdepapperna är endast tillgängliga för, och varje inbjudan, erbjudande eller avtal om att teckna, köpa eller på annat sätt förvärva sådana Värdepapper kommer endast att behandlas avseende relevanta personer. Personer som inte är relevanta personer ska inte handla utifrån eller förlita sig på informationen som finns på denna del av Bolagets webbplats.
          </p>
          
          <p>
            Åtkomst till informationen och dokumenten på följande webbsidor kan vara olaglig i vissa jurisdiktioner, och endast vissa kategorier av personer kan tillåtas åtkomst till sådan information och sådana dokument. Samtliga personer bosatta utanför Sverige som önskar åtkomst till dokumenten på denna webbplats måste först försäkra sig om att de inte är föremål för lokala lagar eller bestämmelser som förbjuder eller inskränker deras rätt till åtkomst av denna webbplats, eller om deras förvärv av värdepapper kräver registrering eller godkännande. Sådan registrering eller sådant godkännande har inte inhämtats utanför Sverige. Bolaget tar inget ansvar för någon persons brott mot tillämpliga lagar och bestämmelser.
          </p>
          
          <div class="mt-6 p-4 bg-gray-50 rounded">
            <p class="font-semibold mb-3">Jag intygar därför att:</p>
            <ol class="list-decimal list-inside space-y-2">
              <li>Jag är bosatt, och befinner mig, utanför USA, Australien, Belarus, Hong Kong, Japan, Kanada, Nya Zeeland, Ryssland, Schweiz, Singapore, Sydafrika och Sydkorea, och</li>
              <li>Jag är bosatt och befinner mig (a) i Sverige eller (b) utanför Sverige och varje sådan jurisdiktion som omnämns under punkt (1) ovan och, under sådana omständigheter, är jag behörig att ta del av informationen och dokumenten på denna webbplats utan begränsning enligt lag och utan att ytterligare åtgärder behöver vidtas av Bolaget.</li>
              <li>Jag har läst, förstått och samtycker till att följa samtliga restriktioner som framgår ovan.</li>
            </ol>
          </div>
        </div>
        
        <div class="mt-8 flex justify-center">
          <button
            class="bg-custom-blue-500 hover:bg-custom-blue-600 text-white font-bold py-3 px-8 rounded-lg transition-colors"
            @click="acceptDisclaimer"
          >
            Jag accepterar
          </button>
        </div>
      </div>
    </div>

    <div v-else class="relative flex flex-col h-auto flex-1 w-full pt-4 pb-20">
      <div class="w-full max-w-[1200px] mx-auto px-4">
        <h1 class="text-4xl font-bold mb-8">Företrädesemission 2026</h1>
        
        <div class="bg-blue-50 border-l-4 border-custom-blue-500 p-6 mb-8">
          <h2 class="text-2xl font-bold mb-4">Teckna enklast här:</h2>
          <div class="space-y-2">
            <p class="text-gray-600">Teckna via Eminova Fondkommission: <a href="https://app.verified.eu/web/eminova-app/?company=windonenergy" target="_blank" class="text-custom-blue-500 hover:underline">Teckna här</a></p>
            <p class="text-gray-600">Teckna via Avanza: <a href="https://www.avanza.se/erbjudanden/svara.html/1767950334203" target="_blank" class="text-custom-blue-500 hover:underline">Teckna här</a></p>
            <p class="text-gray-600">Teckna via Nordnet: <a href="https://www.nordnet.se/foretagshandelser/grupp/150277" target="_blank" class="text-custom-blue-500 hover:underline">Teckna här</a></p>
          </div>
        </div>

        <div class="mb-8">
          <h2 class="text-2xl font-bold mb-4">Företrädesemissionen i sammandrag</h2>
          <div class="space-y-4">
            <p>
              Styrelsen i Windon Energy Group AB ("Windon" eller "Bolaget") har beslutat om en partiellt säkerställd emission av högst 12 160 000 aktier med företrädesrätt för Bolagets aktieägare ("Företrädesemissionen").
            </p>
            <p>
              Emissionslikviden uppgår till cirka 12,2 MSEK före emissionskostnader.
            </p>
            <p>
              Aktieägare som på avstämningsdagen den 8 januari 2026 är registrerade i den av Euroclear Sweden AB förda aktieboken erhåller en (1) teckningsrätt för varje innehavd aktie. En (1) teckningsrätt berättigar till teckning av en (1) ny aktie.
            </p>
            <p>
              Teckningskursen har fastställts till 1 SEK per aktie.
            </p>
            <p>
              Teckningsperioden för Företrädesemissionen pågår från och med den 12 januari 2026 till och med den 26 januari 2026.
            </p>
            <p>
              Företrädesemissionen omfattas till 50 procent av teckningsförbindelser med och utan stöd av företrädesrätt samt garantiåtaganden. Teckningsförbindelserna har erhållits från Bolagets styrelse och ledning samt befintliga aktieägare, vilka sammanlagt uppgår till cirka 1,5 MSEK eller cirka 12,2 procent av Företrädesemissionen. Medlemmar i styrelse och ledning som har lämnat teckningsförbindelser är Johan Kjell (ordförande), Vahid Toosi (ledamot), Christoffer De Geer (ledamot), Michaela Berglund via bolag (ledamot), Henrik Karstensen (ledamot), Christoffer Johansson (VD), Carl-Marcus Aman (COO) och Christer Nilsson via bolag (CTO). Lämnade garantiåtaganden uppgår till cirka 4,6 MSEK eller cirka 37,8 procent av Företrädesemissionen och har lämnats av ett antal externa investerare.
            </p>
          </div>
        </div>

        <div class="mb-8">
          <h2 class="text-2xl font-bold mb-4">Preliminär tidplan</h2>
          <div class="bg-white shadow rounded-lg overflow-hidden">
            <table class="w-full">
              <tbody class="divide-y divide-gray-200">
                <tr>
                  <td class="px-6 py-4 font-medium">8 januari 2026:</td>
                  <td class="px-6 py-4">Avstämningsdag för deltagande i Företrädesemissionen</td>
                </tr>
                <tr>
                  <td class="px-6 py-4 font-medium">12 januari – 26 januari 2026:</td>
                  <td class="px-6 py-4">Teckningsperiod för Företrädesemissionen</td>
                </tr>
                <tr>
                  <td class="px-6 py-4 font-medium">12 januari – 21 januari 2026:</td>
                  <td class="px-6 py-4">Handel i teckningsrätter</td>
                </tr>
                <tr>
                  <td class="px-6 py-4 font-medium">12 januari 2026:</td>
                  <td class="px-6 py-4">Första dag för handel i Betalda Tecknade Aktier (BTA)</td>
                </tr>
                <tr>
                  <td class="px-6 py-4 font-medium">28 januari 2026:</td>
                  <td class="px-6 py-4">Preliminärt datum för offentliggörande av utfallet i Företrädesemissionen</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="mb-8">
          <h2 class="text-2xl font-bold mb-4">Dokument / bilagor</h2>
          <div class="space-y-3">
            <a
              class="flex items-center p-4 bg-white shadow rounded-lg hover:bg-gray-50 transition-colors"
              href="/rights_issue/informationsdokument.pdf"
              target="_blank"
              title="Förenklat informationsdokument"
            >
              <i class="bx bxs-file-pdf text-red-600 text-3xl mr-4" />
              <span class="text-custom-blue-500 font-medium">Förenklat informationsdokument</span>
            </a>
            
            <a
              class="flex items-center p-4 bg-white shadow rounded-lg hover:bg-gray-50 transition-colors"
              href="/rights_issue/anmalningssedel.pdf"
              target="_blank"
              title="Anmälningssedel – teckning utan stöd av teckningsrätter"
            >
              <i class="bx bxs-file-pdf text-red-600 text-3xl mr-4" />
              <span class="text-custom-blue-500 font-medium">Anmälningssedel – teckning utan stöd av teckningsrätter</span>
            </a>
            
            <a
              class="flex items-center p-4 bg-white shadow rounded-lg hover:bg-gray-50 transition-colors"
              href="/rights_issue/vagledning_teckning_av_aktier.pdf"
              target="_blank"
              title="Vägledning för teckning av aktier"
            >
              <i class="bx bxs-file-pdf text-red-600 text-3xl mr-4" />
              <span class="text-custom-blue-500 font-medium">Vägledning för teckning av aktier</span>
            </a>
          </div>
        </div>
      </div>
    </div>
    
    <Footer
      class="w-full"
      @go-to-index="$emit('go-to-index', $event)"
    />
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import Footer from '@/components/Footer'

export default {
  name: 'RightsIssue2026',
  components: {
    Footer
  },
  setup () {
    const showDisclaimer = ref(true)

    const acceptDisclaimer = () => {
      showDisclaimer.value = false
      sessionStorage.setItem('rightsIssueDisclaimerAccepted', 'true')
    }

    onMounted(() => {
      const disclaimerAccepted = sessionStorage.getItem('rightsIssueDisclaimerAccepted')
      if (disclaimerAccepted === 'true') {
        showDisclaimer.value = false
      }
    })

    return {
      showDisclaimer,
      acceptDisclaimer
    }
  }
}
</script>

<style lang="scss" scoped>
.rights-issue {
  p {
    @apply my-2;
  }
  
  h1, h2, h3, h4 {
    @apply font-bold;
  }

  h1 {
    @apply text-4xl pb-2 mb-4;
  }

  h2 {
    @apply text-2xl;
  }

  h3 {
    @apply text-xl;
  }

  h4 {
    @apply text-lg;
  }
  
  a {
    @apply text-custom-blue-500;
  }
}
</style>
